import React from "react";
import {
  Col,
  Row,
  Input,
  Label,
  FormFeedback,
  Badge,
} from "reactstrap";
import Select from "react-select";

interface UserRoleFormProps {
  validation: any;
  roles?: any[];
  selectedUser?: any;
  isUserDisabled?: boolean;
  selectedRoles?: number[];
  onRemoveRole?: (roleId: number) => void;
  existingUserRoles?: number[];
}

const UserRoleForm: React.FC<UserRoleFormProps> = ({
  validation,
  roles = [],
  selectedUser,
  isUserDisabled = false,
  selectedRoles = [],
  onRemoveRole,
  existingUserRoles = [],
}) => {
  const roleOptions = roles
    .filter((role) => 
      role.status === "Active" && 
      !selectedRoles.includes(role.roleid) &&
      !existingUserRoles.includes(role.roleid)
    )
    .map((role) => ({
      label: role.rolename,
      value: role.roleid,
    }));

  const selectedRoleNames = roles
    .filter((role) => selectedRoles.includes(role.roleid))
    .map((role) => ({
      roleid: role.roleid,
      rolename: role.rolename,
    }));

  const handleRoleSelect = (e: { value: any } | null) => {
    if (e?.value) {
      const currentSelected = validation.values.selectedRoles || [];
      if (!currentSelected.includes(e.value)) {
        validation.setFieldValue("selectedRoles", [...currentSelected, e.value]);
        validation.setFieldValue("roleid", ""); // Clear the dropdown
      }
    }
  };

  return (
    <Row className="g-3">
      {selectedUser && (
        <Col md={12}>
          <Label className="fw-bold mb-1">
            Username
          </Label>
          <Input
            type="text"
            name="username"
            value={selectedUser.username || ""}
            disabled={isUserDisabled}
            readOnly
            className="bg-light"
          />
        </Col>
      )}
      <Col md={12}>
        <Label className="fw-bold mb-1">
          Role <span className="text-danger">*</span>
        </Label>
        <div style={{ width: "100%" }}>
          <Select
            options={roleOptions}
            name="roleid"
            placeholder="Select Role"
            value={roleOptions.find((opt) => opt.value === Number(validation.values.roleid)) || null}
            onChange={handleRoleSelect}
            onBlur={() => validation.setFieldTouched("selectedRoles", true)}
            classNamePrefix="react-select"
            className={validation.touched.selectedRoles && validation.errors.selectedRoles ? "react-select-error" : ""}
          />
        </div>
        {validation.touched.selectedRoles && validation.errors.selectedRoles && (
          <div className="invalid-feedback d-block">{validation.errors.selectedRoles}</div>
        )}
      </Col>
      {selectedRoleNames.length > 0 && (
        <Col md={12}>
          <Label className="fw-bold mb-2">Selected Roles:</Label>
          <div className="d-flex flex-wrap gap-2">
            {selectedRoleNames.map((role) => (
              <Badge
                key={role.roleid}
                color="primary"
                className="p-2 d-flex align-items-center gap-2"
                style={{ fontSize: "14px" }}
              >
                {role.rolename}
                <i
                  className="ri-close-line cursor-pointer"
                  onClick={() => onRemoveRole?.(role.roleid)}
                  style={{ cursor: "pointer" }}
                ></i>
              </Badge>
            ))}
          </div>
        </Col>
      )}
    </Row>
  );
};

export default UserRoleForm;
